unit uRep1;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls,
  Vcl.Controls, Vcl.Imaging.pngimage, WEBLib.Buttons;

type
  TFRep1 = class(TForm)
    WebSpeedButton11: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebEdit1: TEdit;
    WebEdit2: TEdit;
    WebEdit3: TEdit;
    WebEdit4: TEdit;
    procedure WebSpeedButton11Click(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  FRep1: TFRep1;

implementation

{$R *.dfm}

procedure TFRep1.WebSpeedButton10Click(Sender: TObject);
begin
FRep1.Hide;
end;

procedure TFRep1.WebSpeedButton11Click(Sender: TObject);
Var
Opcion, Empleado, Puesto, Depto, URL: string;
begin
Opcion:='Rep1';
Puesto:=WebEdit1.Text;
Empleado:=WebEdit2.Text;
Depto:=WebEdit3.Text;

if Puesto = '' then
  begin
    ShowMessage('El campo puesto no se ha capturado!!!');
    Exit;
  end;

if Empleado = '' then Empleado:='0';
if Depto = '' then Depto:='0';

URL := 'http://207.244.241.82:9000/PDFReporteQR?Opcion='+Opcion+
  '&Empleado='+Empleado+
  '&Puesto='+Puesto+
  '&Depto='+Depto;
  asm
  window.open(URL, '_blank');
  end;
end;

procedure TFRep1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  try
    Name := 'FRep1';
    Width := 639;
    Height := 461;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 38;
    WebLabel1.Top := 33;
    WebLabel1.Width := 37;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Puesto:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 38;
    WebLabel2.Top := 80;
    WebLabel2.Width := 105;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'N'#250'mero de empleado:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(Self);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 38;
    WebLabel12.Top := 127;
    WebLabel12.Width := 73;
    WebLabel12.Height := 13;
    WebLabel12.Caption := 'Departamento:';
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 38;
    WebLabel13.Top := 174;
    WebLabel13.Width := 37;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Correo:';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebSpeedButton11.SetParentComponent(Self);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 257;
    WebSpeedButton11.Top := 102;
    WebSpeedButton11.Width := 119;
    WebSpeedButton11.Height := 44;
    WebSpeedButton11.Caption := 'Imprimir';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.Glyph.LoadFromFile('uRep1.WebSpeedButton11.Glyph.png');
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebSpeedButton10.SetParentComponent(Self);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 257;
    WebSpeedButton10.Top := 52;
    WebSpeedButton10.Width := 119;
    WebSpeedButton10.Height := 44;
    WebSpeedButton10.Caption := 'Salir';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uRep1.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebEdit1.SetParentComponent(Self);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 38;
    WebEdit1.Top := 52;
    WebEdit1.Width := 155;
    WebEdit1.Height := 22;
    WebEdit1.ChildOrder := 6;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.WidthPercent := 100.000000000000000000;
    WebEdit2.SetParentComponent(Self);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 38;
    WebEdit2.Top := 99;
    WebEdit2.Width := 155;
    WebEdit2.Height := 22;
    WebEdit2.ChildOrder := 6;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.WidthPercent := 100.000000000000000000;
    WebEdit3.SetParentComponent(Self);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 38;
    WebEdit3.Top := 146;
    WebEdit3.Width := 155;
    WebEdit3.Height := 22;
    WebEdit3.ChildOrder := 6;
    WebEdit3.HeightPercent := 100.000000000000000000;
    WebEdit3.WidthPercent := 100.000000000000000000;
    WebEdit4.SetParentComponent(Self);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 38;
    WebEdit4.Top := 193;
    WebEdit4.Width := 155;
    WebEdit4.Height := 22;
    WebEdit4.ChildOrder := 6;
    WebEdit4.HeightPercent := 100.000000000000000000;
    WebEdit4.WidthPercent := 100.000000000000000000;
  finally
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
  end;
end;

end.
